import { MouseEvent } from 'react';
import {
  FormConfigurationProvider,
  isUserWithRoles,
  useCombinedUser,
  useIsMsalAuth,
  UserRoles,
  useProgrammaticLink,
} from '@equifinance/shared';
import styled from 'styled-components';
import ProductSidebarFooter from '../components/Products/ProductSidebar/ProductSidebarFooter';
import ManageUserSidebar from '../components/ManageUser/components/ManageUserSidebar';
import UserManagementSection from '../components/ManageUser/sections/UserManagementSection';
import ApiManagementSection from '../components/ManageUser/sections/ApiSection';
import CompanyTabPage, { CompanyPageType } from '../components/Company/components/CompanyTabPage';

export const ErrorContainer = styled.div` ${({ theme }) => `
  padding-bottom:${theme.padding[4]};
`}`;

export default function ManageUserPage() {
  const clickHomeLink = useProgrammaticLink('/');

  const isInternalUser = useIsMsalAuth();
  const { user } = useCombinedUser();

  const isReadOnlyUser = isInternalUser && isUserWithRoles([UserRoles.READ_ONLY], user);

  const onClickLogo = (event?: MouseEvent<HTMLElement>) => {
    clickHomeLink(event);
  };

  return (
    <CompanyTabPage
      sidebar={<ManageUserSidebar />}
      sidebarFooter={<ProductSidebarFooter />}
      onClickLogo={onClickLogo}
      page={CompanyPageType.MANAGE_USER}
    >
      <FormConfigurationProvider isReadOnlyInput={isReadOnlyUser}>
        <UserManagementSection />
        <ApiManagementSection />
      </FormConfigurationProvider>
    </CompanyTabPage>
  );
}
